import { TableSortLabel, Paper, Alert, IconButton, Stack } from "@mui/material";
import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { roundStringNumberToInt } from "../../helpers/businessleaderDashboardHelpers";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs from "dayjs";
import { additionalQueriestableHeadings06 } from "./AdditionalQueriesConstants";
import DownloadIcon from "@mui/icons-material/Download";
import { saveAs } from "file-saver";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { Link } from "@mui/material";

interface Props {
  conversionLoadingPercLast14DaysData: any;
}

export const ConversionLoadingPercentage: React.FC<Props> = React.memo(
  ({ conversionLoadingPercLast14DaysData }) => {
    const [searchParams] = useSearchParams();
    const selectedSharedUidBuiURL = searchParams.get(
      "selectedSharedUids"
    ) as string;
    const selectedDimensionsURL = searchParams.get(
      "selectedDimension"
    ) as string;
    const selectedTypeURL = searchParams.get("selectedType") as string;
    const selectedAllURL = searchParams.get("selectedAll") as string;

    const headCells = Object.entries(additionalQueriestableHeadings06);

    const rows = conversionLoadingPercLast14DaysData;

    const [order, setOrder] = useState("desc") as any;
    const [orderBy, setOrderBy] = useState("brand_action_date") as any;

    const parseValue = (value: any) => {
      if (typeof value === "string") {
        if (value.includes("%")) {
          return parseFloat(value.replace("%", ""));
        }
        if (value.includes("$")) {
          return parseFloat(value.replace("$", ""));
        } else {
          return value.toLowerCase();
        }
      } else if (value === null || !value) {
        return "";
      }
      return value;
    };

    const handleRequestSort = (property: any) => {
      const isAscending = orderBy === property && order === "asc";
      setOrder(isAscending ? "desc" : "asc");
      setOrderBy(property);
    };

    const sortedRows = [...rows].sort((a, b) => {
      const aValue = parseValue(a[orderBy]);
      const bValue = parseValue(b[orderBy]);

      if (aValue < bValue) {
        return order === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });

    const handleExportCSV = () => {
      const csvRows = [];

      // Extract the table headers
      const headers = headCells.map((pair) => pair[0]) as any;
      csvRows.push(headers.join(","));

      // Extract the table data
      // eslint-disable-next-line
      sortedRows.map((row: any) => {
        let rowData = [] as any;
        rowData.push(dayjs(row?.brand_action_date).format("DD-MM-YYYY"));
        rowData.push(Math.round(row?.Total_ftd));
        rowData.push(Math.round(row?.FTD_loaded));
        rowData.push(Math.round(row?.perc_loaded_from_total * 100) + "%");
        rowData.push(Math.round(row?.Total_Qftd));
        rowData.push(Math.round(row?.QFTD_loaded));
        rowData.push(Math.round(row?.Qftd_perc_loaded_from_total * 100) + "%");
        csvRows.push(rowData.join(","));
      });

      // Convert CSV rows to a single string
      const csvString = csvRows.join("\n");

      // Create a blob and download the file
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "ConversionLoadingPercentage.csv");
    };

    return (
      <>
        <TableContainer
          className="RunRateTableWrap"
          component={Paper}
          sx={{ boxShadow: "none", maxHeight: 400, overflowY: "auto" }}
        >
          {rows?.length > 0 ? (
            <>
              <Stack
                flexDirection={"row"}
                alignItems="center"
                gap={2}
                margin="4px 16px"
              >
                <Alert
                  sx={{
                    color: "#ED6C02",
                    margin: "16px",
                    border: "1px solid #ED6C0280",
                    width: "100%",
                  }}
                  severity="warning"
                  icon={<InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />}
                >
                  PLEASE NOTE: Data is only relevant for the period of{" "}
                  {dayjs(
                    sortedRows[sortedRows.length - 1].brand_action_date
                  ).format("DD-MM-YYYY")}{" "}
                  -{" "}
                  {dayjs(sortedRows[0].brand_action_date).format("DD-MM-YYYY")}
                </Alert>
                <IconButton color="secondary" size="large" data-tracker="280">
                  <DownloadIcon fontSize="medium" onClick={handleExportCSV} />
                </IconButton>
              </Stack>
              <Table aria-label="collapsible table" size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    {headCells.map(([key, value], index) => (
                      <TableCell
                        key={index + "headCell" + Math.random()}
                        align="left"
                      >
                        <TableSortLabel
                          active={orderBy === key}
                          direction={orderBy === key ? order : "asc"}
                          onClick={() => handleRequestSort(key)}
                        >
                          {value}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedRows?.map((row: any, rowIndex: any) => (
                    <React.Fragment
                      key={rowIndex + "sortedConversion" + Math.random()}
                    >
                      <TableRow
                        sx={{
                          "&:not(:last-child) > *": {
                            borderBottom:
                              "1px solid rgba(224, 224, 224, 1) !important",
                          },
                        }}
                      >
                        <TableCell
                          key={rowIndex + "tabelCellCon" + Math.random()}
                          align="left"
                        >
                          {dayjs(row?.brand_action_date).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell
                          key={2 + "tabelCellCon" + Math.random()}
                          align="left"
                        >
                          {roundStringNumberToInt(row?.Total_ftd)}
                        </TableCell>
                        <TableCell
                          key={3 + "tabelCellCon" + Math.random()}
                          align="left"
                        >
                          {roundStringNumberToInt(row?.FTD_loaded)}
                        </TableCell>
                        <TableCell
                          key={4 + "tabelCellCon" + Math.random()}
                          align="left"
                        >
                          <Link
                            data-tracker="453"
                            component={RouterLink}
                            to={{
                              pathname:
                                "/business_leader/dashboard/FTD_loaded_from_total",
                              search: `?selectedSharedUids=${selectedSharedUidBuiURL}&selectedDimension=${selectedDimensionsURL}&selectedType=${selectedTypeURL}&selectedAll=${selectedAllURL}&startDate=${row?.brand_action_date}&endDate=${row?.brand_action_date}&selectedActionType=ftd`,
                            }}
                            color="secondary"
                            underline="hover"
                          >
                            {roundStringNumberToInt(
                              row?.perc_loaded_from_total * 100
                            ) + "%"}
                          </Link>
                        </TableCell>
                        <TableCell
                          key={5 + "tabelCellCon" + Math.random()}
                          align="left"
                        >
                          {roundStringNumberToInt(row?.Total_Qftd)}
                        </TableCell>
                        <TableCell
                          key={6 + "tabelCellCon" + Math.random()}
                          align="left"
                        >
                          {roundStringNumberToInt(row?.QFTD_loaded)}
                        </TableCell>
                        <TableCell
                          key={7 + "tabelCellCon" + Math.random()}
                          align="left"
                        >
                          <Link
                            data-tracker="453"
                            component={RouterLink}
                            to={{
                              pathname:
                                "/business_leader/dashboard/QFTD_loaded_from_total",
                              search: `?selectedSharedUids=${selectedSharedUidBuiURL}&selectedDimension=${selectedDimensionsURL}&selectedType=${selectedTypeURL}&selectedAll=${selectedAllURL}&startDate=${row?.brand_action_date}&endDate=${row?.brand_action_date}&selectedActionType=qftd`,
                            }}
                            color="secondary"
                            underline="hover"
                          >
                            {roundStringNumberToInt(
                              row?.Qftd_perc_loaded_from_total * 100
                            ) + "%"}
                          </Link>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </>
          ) : (
            ""
          )}
        </TableContainer>
      </>
    );
  }
);
